exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".view-operations[data-v-60fbae5c]{display:none}.widget-view[data-v-60fbae5c]{margin-bottom:0!important}.active[data-v-60fbae5c]{border:2px solid #409eff!important}.active .view-operations[data-v-60fbae5c]{position:absolute;bottom:-5px;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer}.grid-template[data-v-60fbae5c]{margin-left:-100px!important}.grid-template>.columns[data-v-60fbae5c]{border:2px solid #9999;height:50px}.radioLineHeight[data-v-60fbae5c]{line-height:32px}.form-text[data-v-60fbae5c]{margin-left:-100px}.form-rate-number[data-v-60fbae5c]{width:30px;height:30px;float:left;border:1px solid #000;text-align:center;font-weight:700;margin-top:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-60fbae5c","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/formBuilder/widgetFormItem.vue
// module id = yyRX
// module chunks = 0